import { KLAGE_SAKSBEHANDLERRAPPORT } from "../actions/klager/klageAction";
import { CreateNewReducer } from "../utils/reducerUtils";

const klageRapportSaksbehandlerReducer = (state = {}, action) =>
  CreateNewReducer(state, action, KLAGE_SAKSBEHANDLERRAPPORT, true);

export default klageRapportSaksbehandlerReducer;
